export default __webpack_public_path__ + "static/media/8.63385b1c.webp";